import { BalancesModel } from '@src/core/domain/balance/balances.model';
import { Observable } from 'rxjs';

export abstract class BalancesRepository {
  abstract getAllBalances(): Observable<BalancesModel>;
}
